import { Component, ContentChild, TemplateRef, ViewChild, ViewEncapsulation, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { PhxDropdownService } from './phx-dropdown.service';
import { PhxContextService } from '../../services/phx-context-service';
import { PhxFormService } from '../../services/phx-form-service';
import { PhxMenuComponent } from '../menu/phx-menu/phx-menu.component';

@Component({
  selector: 'phx-dropdown',
  exportAs: `phxDropdown`,
  templateUrl: './phx-dropdown.component.html',
  styleUrls: ['./phx-dropdown.component.scss'],
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'phx-dropdown',
    '(keydown)': 'onKeydown($event)',
  },
  providers: [PhxDropdownService, { provide: PhxContextService, useClass: PhxFormService }],
})
export class PhxDropdownComponent {
  /**
   * Whether to enable keyboard navigation.
   * When false, arrow key navigation is disabled to prevent conflicts with components that handle their own focus (like typeahead).
   * When true, the first menu item will be focused when the user presses the arrow down key.
  */
  @Input() public phxEnableKeyboardNav: boolean = true;

  @ViewChild('dropdownTemplate', { static: true }) public templateRef!: TemplateRef<any>;
  @ContentChild(PhxMenuComponent) private menu?: PhxMenuComponent;

  public descendantMenuItemClick: Subject<any>;
  public toggle$: Subject<boolean>;

  constructor(private dropdownService: PhxDropdownService) {
    this.descendantMenuItemClick = this.dropdownService.descendantMenuItemClick;
    this.toggle$ = this.dropdownService.toggle$;
  }

  public focusFirstMenuItem(): void {
    if (this.phxEnableKeyboardNav && this.menu) {   // Only focus if keyboard navigation is enabled
      this.menu.onFocus();
    }
  }

  public onKeydown(event: KeyboardEvent): void {
    if (event.key === 'Escape') {
      this.toggle$.next(false);
      event.preventDefault();
    }
  }
}